'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var FsMap = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_fsmap',
		type: null
	},

	initialize: function initialize(options) {
		this.setOptions(options);

		this.build();
	},

	build: function build() {
		var opts = this.options,
		    self = this;

		this._element = new Element('div', { 'class': opts.cls + ' ' + opts.type });
		this._fsmap_cont = new Element('div', { 'class': opts.cls + '_cont', 'html': '<div class="' + opts.cls + '_header"><h3 class="title">' + document.getElement('.page_title h1').get('text') + '</h3></div><div class="w_fsmap_map"><div class="map"></div></div>' }).inject(this._element);

		this._veil = new Element('.w_fsmap_veil').inject(this._fsmap_cont);

		var events = {};

		events['click:relay(.' + opts.cls + '_link)'] = function (e, _el) {
			if (e && e.stop) e.stop();

			self.clicked_element = _el;

			_gaq.push(['_trackEvent', _el.getAttribute('data-track-category'), _el.getAttribute('data-track-action'), _el.getAttribute('data-track-label')]);

			(function () {
				self.open_map();
			}).delay(50);
		};

		events['keydown'] = function (e) {
			if (e.code == 27) {
				//esc key
				self.close_map();
			}
		};

		document.addEvents(events);
	},

	open_map: function open_map() {
		this._element.setStyles({
			'visibility': 'hidden',
			'opacity': 0
		});

		this._element.inject(document.body);
		this._element.fade('in');

		if (!this.map) {
			this.load_map();
		}

		Cookie.write('sr_view', 'map', { duration: 1 });

		this.fireEvent('openMap');
	},

	close_map: function close_map() {
		this._element.fade('out');

		(function () {
			this._element.dispose();
		}).bind(this).delay(1000);

		Cookie.write('sr_view', 'list', { duration: 1 });

		this.fireEvent('closeMap');
	},

	load_map: function load_map() {
		var self = this;
		this._fsmap_cont.addClass('_loading');

		var _map = this._fsmap_cont.getElement('.map');

		this.map = new SimpleMap(_map, {
			zoom_control_style: 'small',
			max_zoom: 17,
			min_zoom: 10,
			onMapReady: function onMapReady() {
				self.fireEvent('mapReady');
			}
		});
	}
});
'use strict';

var MapView = new Class({
	Implements: [Events, Options],

	options: {
		auto_open: false,
		back_button: true,
		counts_only: false,
		icon_path: null,
		with_hover_icon: true,
		with_filter: false,
		filter_param: '',
		add_class: null
	},

	initialize: function initialize(options) {
		this.setOptions(options);

		if (this.options.auto_open) {

			this._click_el = document.getElement('.forced_map');

			if (!this._click_el) return;

			this.create_map();

			if (_gaq) {
				_gaq.push(['_trackEvent', this._click_el.getAttribute('data-track-category'), this._click_el.getAttribute('data-track-action'), this._click_el.getAttribute('data-track-label')]);
			}

			this.fs_map.open_map();
		} else {
			this.create_map();
		}

		if (this.options.back_button) {
			this.create_close_button();
		}
	},

	create_map: function create_map() {
		var self = this;
		var opts = this.options;
		var firstload = true;
		var sr_map;

		var __setMap = function __setMap() {
			var rpc;

			if (opts.auto_open) {
				rpc = self._click_el.get('data-rpc');

				if (self._click_el.getAttribute('data-type')) {
					rpc += '?type=' + self._click_el.getAttribute('data-type');
				}
			} else {
				rpc = fs_map.clicked_element.get('data-rpc');
			}

			if (sr_map) {
				sr_map.clear_regions();
			}

			sr_map = self.sr_map = new SearchResultsMap(fs_map.map, {
				is_building: true,
				counts_only: self.options.counts_only,
				data_rpc: rpc,
				icon_path: self.options.icon_path,
				with_hover_icon: self.options.with_hover_icon,

				onRequest: function onRequest(e) {
					fs_map._fsmap_cont.addClass('_loading');
				},

				onDataLoad: function onDataLoad(data) {
					fs_map._fsmap_cont.removeClass('_loading');

					// add the filter
					if (self.options.with_filter && data && data.tableTools && data.tableTools.filters && !self.hasFilter) {
						self.create_filter(data.tableTools.filters[0].options);
						self.hasFilter = true;
					}
				}
			});

			// add extra class
			if (self.options.add_class) {
				self.sr_map.map._element.addClass(self.options.add_class);
			}
		};

		var fs_map = this.fs_map = new FsMap({
			onMapReady: function onMapReady() {
				__setMap();
				firstload = false;
			},

			onOpenMap: function onOpenMap() {
				fs_map._fsmap_cont.addClass('_loading');
				fs_map.map.clear_markers();

				if (!firstload) {
					__setMap();
				}

				if (Stalker_instance) {
					if (Stalker_instance._element.hasClass('_down')) {
						Stalker_instance._element.removeClass('_down');
						Stalker_instance._element.previousState = 'down';
					} else {
						Stalker_instance._element.previousState = 'up';
					}

					Stalker_instance._element.addClass('_on_map_view');
					Stalker_instance._element.addClass('show_back_button');

					if (self.options.with_filter) {
						Stalker_instance._element.addClass('show_filter');
					}
				}

				fs_map._fsmap_cont.addEvent('mouseenter', function () {
					document.fireEvent('hideSubMenu');
				});

				fs_map.opened = true;

				self.resize_map();
			},

			onCloseMap: function onCloseMap() {
				if (Stalker_instance) {
					if (Stalker_instance._element.previousState === 'down') {
						Stalker_instance._element.addClass('_down');
					}
					Stalker_instance._element.removeClass('_on_map_view');
					Stalker_instance._element.removeClass('show_back_button');
					Stalker_instance._element.removeClass('show_filter');
				}

				if (sr_map && sr_map.current_big_bubble) {
					sr_map.current_big_bubble.close();
				}

				fs_map.opened = false;
			}
		});
	},

	create_close_button: function create_close_button() {
		var self = this;

		(function () {
			if (Stalker_instance && Stalker_instance._element) {
				var _close = new Element('.w_fsmap_close', {
					'html': '<span class="option gallery"><i class="fa fa-th-list fa18"></i><span>Gallery</span></span> <span class="devider">|</span> <span class="option active"><i class="fa fa-map-marker fa18"></i><span>Map</span></span>'
				});

				_close.inject(Stalker_instance._element);

				_close.getElement('.gallery').addEvent('click', function () {
					self.fs_map.close_map();
				});
			}
		}).delay(1000);
	},

	create_filter: function create_filter(options) {
		var self = this;
		var filter_array = [];

		if (options) {
			var li_options = '';
			options.each(function (option) {
				li_options += '<li data-value="' + option.value + '">' + option.label + '</li>';
			});

			var html = '<div class="header">filter By:<div class="clear_btn">clear filters</div></div><ul>' + li_options + '</ul>';

			var _filter = new Element('.w_fsmap_filter', {
				html: html
			});

			_filter.addEvents({
				'click:relay(li)': function clickRelayLi(e) {
					var filter_param = '';
					this.toggleClass('_active');

					if (this.hasClass('_active')) {
						// add it in the filter array
						filter_array.include(this.get('data-value'));
					} else {
						// remove from the filter array
						filter_array.erase(this.get('data-value'));
					}

					filter_array.each(function (item, i) {
						filter_param += (filter_param.length !== 0 ? '&' : '') + self.options.filter_param + '=' + item;
					});

					// set the filter parameters that will be use on SearchResultsMap widget
					self.sr_map.options.filter_param = filter_param;

					var region = self.sr_map.current_region;
					if (region) {
						// we have to reset selected hood to be able to send a new rpc with the filter
						region.is_active = false;
						region.gross_data = null;
						self.sr_map.handle_region_click(region, null, true);
					} else {
						self.sr_map.get_data();
					}
				},
				'click:relay(div.clear_btn)': function clickRelayDivClear_btn(e) {
					//update the map with no filters
					self.sr_map.current_region = null;
					self.sr_map.options.filter_param = null;
					self.sr_map.get_data();
					filter_array.empty();

					// reset the active filters
					_filter.getElements('li._active').each(function (_li) {
						_li.removeClass('_active');
					});
				}
			});

			_filter.inject(Stalker_instance._element);
		}
	},

	resize_map: function resize_map() {
		var self = this;
		var fs_map = this.fs_map;

		if (!fs_map.opened) return;

		var _header = fs_map._element.getElement('.w_fsmap_header');
		var _map = fs_map._element.getElement('.w_fsmap_map');

		if (!_map) return;

		if (_header) {
			var top = _header.getSize().y;

			if (Stalker_instance && Stalker_instance._element) {
				top = Stalker_instance._element.getSize().y;
			}

			_map.setStyle('top', top);
		}

		_map.getElement('.map').setStyle('height', _map.getSize().y);

		var map = fs_map.map.map;

		if (GoogleApiLoad == 'loaded' && map) {
			google.maps.event.trigger(map, 'resize');
		} else {
			(function () {
				self.resize_map();
			}).delay(500);
		}
	}
});
'use strict';

var PhotogalleryV2 = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_photogalleryv2',
		first_image: null,
		width_by_thumbs: 5, //has to be odd or 0 if thumbs are hidden
		animate: false, //use for slideshow
		scroll_speed: 200,
		in_popup: false,
		thumbs: null, //used for full screen gallery
		show_controllers: false, //always display controllers
		missing_img: null,
		videos: false,
		show_floorplan: false,
		onFsClose: function onFsClose() {}
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;
		this.cls = this.options.cls;
		this.verticalPadding = 10;
		if (this._element) {
			this.build();
			this.adaFix();
		}
	},

	adaFix: function adaFix() {
		this._element.setAttribute('aria-label', 'carousel');
		this._element.setAttribute('role', 'region');
	},

	build: function build() {
		var fcls = '.' + this.cls;
		this.lastScroll = 0;
		this.is_touched = false;
		this.normal_mode = true;
		this.fullscreen_mode = false;
		this._main = this._element.getElement(fcls + '_main');

		if (this.options.videos) {
			this._main.addClass('videos');
		}
		this._bottom = this._element.getElement(fcls + '_bottom');
		this._strip = this._element.getElement(fcls + '_strip');
		this._thumbs = this.options.thumbs || this._strip.getElements('.thumb');

		if (!this._thumbs || this._thumbs.length == 0) {
			this._element.dispose();
			return;
		}

		this.main_cont_width = this._main.getSize().x;
		this.main_cont_height = this._main.getSize().y;
		this.mainFullImgHeights = [];
		this.indexPositions = [];
		this.current_index = 0;

		var error_img_url = this.options.missing_img ? this.options.missing_img : Res_i + '/l/not-found-big-1.png';

		this._thumbs.each(function (_el, _index) {
			if (_el.getAttribute('type') === 'video') {
				_el._full_img = new Element('iframe', {
					class: 'iframe-fullscreen',
					'src': Res_i + '/l/dummy.png',
					'allowfullscreen': 1,
					'onerror': 'this.src=\'' + error_img_url + '\''
				});
			} else {
				_el._full_img = new Element('img', {
					'src': Res_i + '/l/dummy.png'
				});
			}

			_el._full_img_cont = new Element('div', {
				'class': 'full_img_cont'
			});
			if (_index != 0) {
				_el._full_img_cont.setStyles({ 'padding-top': '10px' });
			}
			_el._full_img_cont.adopt(_el._full_img);
			_el._full_img_cont.inject(this._main);

			var url = _el.getElement('img') ? _el.getElement('img').getAttribute('data-url') : null;

			if (url) {
				_el._full_img_cont.setStyle('cursor', 'pointer');

				_el._full_img_cont.addEvent('click', function () {
					window.location = url;
				});
			}
		}.bind(this));

		if (this._thumbs && this._thumbs.length < this.options.width_by_thumbs) {
			var dummies_amount = this.dummies_amount = this.options.width_by_thumbs - this._thumbs.length;

			for (var i = 0; i < dummies_amount; i++) {
				new Element('div', { 'class': 'thumb _dummy', 'html': '&nbsp;' }).inject(this._strip);
			}
		}

		var _controllers = this._main.getElement(fcls + '_controllers');

		if (_controllers && this.options.show_controllers) {
			_controllers.show();
		}

		this._fullscreen = this._main.getElement(fcls + '_fullscreen');
		this._zoomin = this._main.getElement(fcls + '_zoomin');
		this._zoomout = this._main.getElement(fcls + '_zoomout');
		var _photogalleryContainer = document.getElement('.photogalleryv2_container');
		var _photogalleryContainerSize = null;
		if (!!_photogalleryContainer) {
			_photogalleryContainerSize = _photogalleryContainer.getSize();
		}
		if (!!_photogalleryContainerSize) {
			this._floorCurrentWidth = _photogalleryContainerSize.x - 600; // from PagePhotogalleryV2
			this._floorDefaultWidth = _photogalleryContainerSize.x - 600;
			this._floorMaxWidth = _photogalleryContainerSize.x + 600;
			this._floorMinWidth = _photogalleryContainerSize.x - 1200;
		}

		if (!!this.options.show_floorplan) {
			if (!!this._zoomin) {
				this._zoomin.removeClass('none');
			}
			if (!!this._zoomout) {
				this._zoomout.removeClass('none');
			}
		} else {
			if (!!this._zoomin) {
				this._zoomin.addClass('none');
			}
			if (!!this._zoomout) {
				this._zoomout.addClass('none');
			}
		}
		if (!!this.options.videos == true) {
			if (!!this._fullscreen) {
				this._fullscreen.addClass('none');
			}
		} else {
			if (!!this._fullscreen) {
				this._fullscreen.removeClass('none');
			}
		}
		this._enlarge = this._main.getElement(fcls + '_enlarge');
		this._thumbs_left = this._element.getElement(fcls + '_bottom .move_left');
		this._thumbs_right = this._element.getElement(fcls + '_bottom .move_right');
		this._image_counter = this._element.getElement(fcls + '_image_counter');

		this._ajax_loader = new Element('div', {
			'class': 'ajax_loader',
			'html': '&nbsp;'
		});
		this._ajax_loader.inject(this._main, 'top');

		this.to_center = true;

		this.set_appearance();
		this.set_functionality();

		if (this._element.hasClass('_slide')) {
			this.move_caption();
		}
	},

	set_appearance: function set_appearance() {
		var opts = this.options;

		if (opts.first_image && opts.first_image != '') {
			this._thumbs[0]._full_img.setProperty('src', opts.first_image);
			this._thumbs[0]._full_img_cont.fade('show');
		}

		if (opts.width_by_thumbs % 2 == 1) {
			this.margin = this._thumbs[0].getStyle('margin-left').toInt() + this._thumbs[0].getStyle('margin-right').toInt();
			this.thumb_width = this._thumbs[0].getSize().x;
			this.strip_width = (this.thumb_width + this.margin) * (this._thumbs.length + (this.dummies_amount || 0)) - this._thumbs[0].getStyle('margin-left').toInt();

			this.main_width = (this.thumb_width + this.margin) * opts.width_by_thumbs - this._thumbs[0].getStyle('margin-left').toInt();

			this._thumbs[0].setStyle('margin-left', 0);

			this._strip.setStyles({
				'width': this.strip_width,
				'left': 0
			});
		} else {
			this.main_width = this._main.getSize().x;

			var _bottom = this._element.getElement('.' + opts.cls + '_bottom');

			if (_bottom) {
				_bottom.hide();
				this._element.addClass('_no_thumbnails');
			}
		}

		if ((this.main_width == 0 || this.main_width == null) && opts.width) {
			this.main_width = opts.width;
		}

		this.main_height = this._main.getSize().y;

		if (opts.fullscreen) {
			this.img_cont_width = '100%';
			this.img_cont_height = '100%';
			this.main_height = '100%';
		} else {
			var _full_img_cont = this._thumbs[0]._full_img_cont;

			this.img_cont_width = this.main_width - _full_img_cont.getParent().getStyle('padding-left').toInt() * 2 - _full_img_cont.getParent().getStyle('border-width').toInt() * 2;
			this.img_cont_height = this.main_height - _full_img_cont.getParent().getStyle('padding-top').toInt() * 2 - _full_img_cont.getParent().getStyle('border-width').toInt() * 2;
		}

		var zi_1 = this._thumbs[0]._full_img_cont.getStyle('z-index').toInt();

		this._ajax_loader.setStyle('z-index', zi_1 + 1);
		this._ajax_loader.fade('hide');

		this._thumbs.each(function (_el, i) {
			_el.addEvent('click', function () {
				this.to_center = false;
				if (_el.getAttribute('type') == 'video') {
					this.select_video_thumb(i);
				} else {
					this.select_thumb(i);
				}
			}.bind(this));
		}.bind(this));
		this.thumbs_arrows_set_class();
	},

	set_functionality: function set_functionality() {
		var self = this;

		this._main.addEvents({
			'mouseenter': function mouseenter() {
				self._main.addClass('_active');
			},

			'mouseover': function mouseover() {
				self._main.addClass('_active');
			},

			'mouseout': function mouseout() {
				self._main.removeClass('_active');
			},

			'click': function click() {
				var url = self._element.get('data-url') || self._thumbs[self.current_index].get("data-url");

				if (!url) return;

				window.location = url;
			},

			'scroll': function scroll() {
				var currentScroll = self._main.scrollTop; // Get Current Scroll Value

				if (currentScroll > 0 && self.lastScroll <= currentScroll) {
					self.lastScroll = currentScroll;
					self.scrollDirection = 'down';
				} else {
					self.lastScroll = currentScroll;
					self.scrollDirection = 'up';
				}

				var indexFromMainScroll = self.getIndexFromMainScroll();

				if (indexFromMainScroll != self.current_index) {
					var th = self._thumbs[indexFromMainScroll];

					if (!!self._previous_thumb && self._previous_thumb !== th) {
						self._previous_thumb.removeClass('current');
					}

					if (!!th && self._previous_thumb !== th) {
						th.addClass('current');

						if (self.options.videos == true) {
							self.loadVideo(th, indexFromMainScroll);
						} else {
							self.load(th);
						}

						self.current_index = indexFromMainScroll;
						self.setImageCounter(indexFromMainScroll);
						self._previous_thumb = th;

						if (self.options.videos != true) {
							if (!!self.scrollDirection && self.scrollDirection == 'up') {
								self.loadAboveImage();
								self.loadSecondAboveImage();
							} else if (!!self.scrollDirection && self.scrollDirection == 'down') {
								self.loadBelowImage();
								self.loadSecondBelowImage();
							} else {
								self.loadAboveImage();
								self.loadSecondAboveImage();
								self.loadBelowImage();
								self.loadSecondBelowImage();
							}
						}

						self.move_thumbs_auto(indexFromMainScroll);
					}
				}
			}
		});

		if (this._fullscreen) {
			this._fullscreen.addEvents({
				'click': function (e) {
					if (e && e.stop) {
						e.stop();
					}
					if (self.fullscreen_mode) {
						this.go_normal_mode();
					} else {
						this.go_fullscreen_mode();
					}
				}.bind(this),

				'touchstart': function touchstart(e) {
					if (e && e.stop) e.stop();

					self._fullscreen.fireEvent('click');
					return false;
				}
			});
		}

		if (!!this._zoomin && !!this._zoomout && !!this.options.show_floorplan) {
			this._zoomin.addEvents({
				'click': function (e) {
					if (e && e.stop) {
						e.stop();
					}
					this.zoomin_floorplan();
				}.bind(this)
			});

			this._zoomout.addEvents({
				'click': function (e) {
					if (e && e.stop) {
						e.stop();
					}
					this.zoomout_floorplan();
				}.bind(this)
			});
		}

		if (this._thumbs.length == 1) {
			this.hide_controllers();
			return;
		}

		if (this.options.videos == true) {
			this._thumbs.each(function (_el, _index) {
				_el._full_img.addEvent('load', function () {
					self.mainFullImgHeights[_index] = _el._full_img.getSize().y + (_index > 0 ? self.verticalPadding : 0);
				});
			});
			this.select_video_thumb(0);
		} else {
			this.select_thumb(0);
		}

		if (this._thumbs.length > 1) {
			if (this._thumbs.length > this.options.width_by_thumbs) {
				this._thumbs_left.addEvent('click', function (e) {
					if (e && e.stop) e.stop();

					this.to_center = false;
					this.move_thumbs('left');
				}.bind(this));

				this._thumbs_right.addEvent('click', function (e) {
					if (e && e.stop) e.stop();

					this.to_center = false;
					this.move_thumbs('right');
				}.bind(this));

				this.move_strip = new Fx.Morph(this._strip, {
					link: 'ignore',
					duration: this.options.scroll_speed
				});
			} else {
				this._thumbs_left.hide();
				this._thumbs_right.hide();
			}
		}
	},

	select_thumb: function select_thumb(index) {
		if (typeof index === 'string') {
			index = index.toInt();
		}

		var th = this._thumbs[index];

		if (index != 0 && !this.is_touched) {
			this.is_touched = true;
		}

		if (this._previous_thumb && this._previous_thumb !== th) {
			this._previous_thumb.removeClass('current');
		}

		if (!!th && this._previous_thumb !== this._thumbs[index]) {
			th.addClass('current');

			this.current_index = index;
			this.setImageCounter(index);
			this._previous_thumb = th;

			if (index == 0) {
				this.load(th);
				this.scrollMainToPosition(index);
			} else {
				this.loadAllAboveAndCurrentImages(index);
			}

			this.loadBelowImage();
			this.loadSecondBelowImage();
		}

		if (this.to_center == true && this.options.width_by_thumbs % 2 == 1) {
			this.move_thumbs_auto(index);
		}
	},

	select_video_thumb: function select_video_thumb(index) {
		if (typeof index === 'string') {
			index = index.toInt();
		}

		var th = this._thumbs[index];

		if (this._previous_thumb && this._previous_thumb !== th) {
			this._previous_thumb.removeClass('current');
		}

		if (!!th && this._previous_thumb !== this._thumbs[index]) {
			th.addClass('current');
			this.current_index = index;
			this.setImageCounter(index);
			this._previous_thumb = th;
			this.loadVideo(th, index);
			this.scrollMainToPosition(index);
		}
	},

	scrollMainToPosition: function scrollMainToPosition(index) {
		if (!!this.mainFullImgHeights && !!this.mainFullImgHeights.length) {
			var pos = 0;
			for (var i = 0; i < index; i++) {
				pos += this.mainFullImgHeights[i];
			}
			this._main.scrollTop = pos;
		}
	},

	getIndexFromMainScroll: function getIndexFromMainScroll() {
		var _mainRect = this._main.getBoundingClientRect();
		var _mainTop = _mainRect.top;
		var foundIndex = this.current_index;

		for (var _index = 0; _index < this._thumbs.length; _index++) {
			var _el = this._thumbs[_index];
			var _elRect = _el._full_img.getBoundingClientRect();
			var _elTop = _elRect.top;
			var tmp = Math.round(_elTop);

			if (!this.fullscreen_mode) {
				if (_elTop > 0 && _elTop <= _mainTop) {
					foundIndex = _index;
					_index = this._thumbs.length;
				}
			} else {
				if (tmp >= 0 && tmp <= 70) {
					foundIndex = _index;
					_index = this._thumbs.length;
				}
			}
		}

		return foundIndex;
	},

	load: function load(th) {
		var path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
		this.hide_ajax_loader();
		this._current_full_img_cont = th._full_img_cont;
		this.update_caption(th);
		this.fireEvent('showImage');
	},

	loadVideo: function loadVideo(th, index) {
		var src = th._full_img.get('src');
		if (src == Res_i + '/l/dummy.png') {
			var path = this.getThPathWithWidth(th);
			if (!!path) {
				th._full_img.set('src', path);
			}
			var error_img_url = th.getAttribute('data-error');
			if (!!error_img_url) {
				th._full_img.set('onerror', 'this.src = \'' + error_img_url + '\'');
			}

			this.hide_ajax_loader();
			this.fireEvent('showImage');
		}
	},

	getAboveTh: function getAboveTh() {
		var aboveTh = null;
		// not first
		if (this.current_index != 0) {
			aboveTh = this._thumbs[this.current_index - 1];
		}
		return aboveTh;
	},

	getSecondAboveTh: function getSecondAboveTh() {
		var secondAboveTh = null;
		// not second
		if (this.current_index != 1) {
			secondAboveTh = this._thumbs[this.current_index - 2];
		}
		return secondAboveTh;
	},

	getBelowTh: function getBelowTh() {
		var belowTh = null;
		// not last
		if (this.current_index != this._thumbs.length - 1) {
			belowTh = this._thumbs[this.current_index + 1];
		}
		return belowTh;
	},

	getSecondBelowTh: function getSecondBelowTh() {
		var secondBelowTh = null;
		// not before last
		if (this.current_index != this._thumbs.length - 2) {
			secondBelowTh = this._thumbs[this.current_index + 2];
		}
		return secondBelowTh;
	},

	getThPathWithWidth: function getThPathWithWidth(th) {
		var path = null;
		if (!!th) {
			path = th.getAttribute('data-full');
		}
		return path;
	},

	loadImage: function loadImage(th, path) {
		var self = this;
		if (!!th && !!path) {
			new Asset.image(path, {
				onLoad: function onLoad() {
					th._full_img.set('src', path);
					self._thumbs.each(function (_el, _index) {
						self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
					});
				}
			});
		}
	},

	loadAboveImage: function loadAboveImage() {
		var th = this.getAboveTh();
		var path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
	},

	loadSecondAboveImage: function loadSecondAboveImage() {
		var th = this.getSecondAboveTh();
		var path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
	},

	loadAllAboveAndCurrentImages: function loadAllAboveAndCurrentImages(selectedThumbIndex) {
		var self = this;
		var myPromise = new Promise(function (myResolve, myReject) {
			var _loop = function _loop(i) {
				var th = self._thumbs[i];
				var path = self.getThPathWithWidth(th);
				// this.loadImage(th, path, selectedThumbIndex);
				if (!!th && !!path) {

					new Asset.image(path, {
						onLoad: function onLoad() {
							th._full_img.set('src', path);

							self._thumbs.each(function (_el, _index) {
								self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
							});

							// if all images before selectedThumbIndex are loaded call myResolve
							var cntLoaded = 0;
							for (var ii = 0; ii <= selectedThumbIndex; ii++) {
								// default height is 11 (1 px + 10 px padding-top)
								if (self.mainFullImgHeights[ii] != 11) {
									cntLoaded++;
								}
							}

							if (cntLoaded == selectedThumbIndex + 1) {
								myResolve(selectedThumbIndex);
							}
						}
					});
				}
			};

			// some code which takes time
			for (var i = 0; i <= selectedThumbIndex; i++) {
				_loop(i);
			}
		});

		myPromise.then(function (selectedThumbIndex) {
			self.scrollMainToPosition(selectedThumbIndex);
		});
	},

	loadBelowImage: function loadBelowImage() {
		var th = this.getBelowTh();
		var path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
	},

	loadSecondBelowImage: function loadSecondBelowImage() {
		var th = this.getSecondBelowTh();
		var path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
	},

	hide_ajax_loader: function hide_ajax_loader() {
		this._ajax_loader.setStyles({
			opacity: 0,
			visibility: 'hidden'
		});
	},

	go_fullscreen_mode: function go_fullscreen_mode() {
		this.get_parent();
		this.normal_mode = false;
		this.fullscreen_mode = true;

		var self = this;
		this._fs_gallery = new Element('div', { 'class': 'w_fs_gallery', 'aria-label': 'modal dialog', 'role': 'region' }).inject(document.body);
		var _fs_gallery_cont = new Element('div', { 'class': 'w_fs_gallery_cont' }).inject(this._fs_gallery);
		var _fs_close = new Element('button', { 'class': 'w_fs_close', 'html': 'Close' }).inject(_fs_gallery_cont);

		_fs_close.addEvent('click', function () {
			self.go_normal_mode();
		});

		this._element.inject(_fs_gallery_cont);

		if (!!this.options.show_floorplan) {
			this._floorCurrentWidth = this._floorDefaultWidth;
		}
		this._thumbs.each(function (_el, _index) {
			_el._full_img.setStyles({
				'width': '100%'
			});
			self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
		});

		this.scrollMainToPosition(this.current_index);

		this.removeTabbingRestriction = Core.disableTabbingOutside(this._fs_gallery);
		_fs_close.focus();
	},

	center_element: function center_element(_element) {
		_element.setStyles({
			position: 'absolute'
		});

		var win_scroll = window.getScroll(),
		    win_size = window.getSize(),
		    el_size = _element.getSize();

		var pos_y = win_scroll.y + Math.floor(Math.max(0, (win_size.y - el_size.y) / 2));

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			win_size.x = Math.max(win_size.x, document.getElement('body').offsetWidth);
		}

		var pos_x = win_scroll.x + Math.floor(Math.max(0, (win_size.x - el_size.x) / 2));

		_element.setStyles({
			top: pos_y,
			left: pos_x
		});
	},

	get_parent: function get_parent() {
		this._parent = this._element.getParent();
	},

	restore_to_parent: function restore_to_parent() {
		this._element.inject(this._parent);
	},

	go_normal_mode: function go_normal_mode() {
		var self = this;
		this.restore_to_parent();
		var trigger;
		if (this._fs_gallery) {
			this._fs_gallery.destroy();
			this.fullscreen_mode = false;
			trigger = this._fullscreen;
		}
		if (this._veil) {
			this._veil.destroy();
		}
		if (this._en_gallery) {
			this._en_gallery.destroy();
			trigger = this._enlarge;
		}
		this.normal_mode = true;
		this.fireEvent('fsClose');

		if (!!this.options.show_floorplan) {
			this._main.setStyles({ 'overflow-x': 'hidden' });
		}

		this._thumbs.each(function (_el, _index) {
			_el._full_img.setStyles({
				'width': 'auto'
			});
			self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
		});

		this.scrollMainToPosition(this.current_index);

		trigger && trigger.focus();
		this.removeTabbingRestriction();
	},

	move_thumbs: function move_thumbs(side) {
		if (side == 'left' && !this._thumbs_left.hasClass('inactive')) {
			var move = this._strip.getStyle('left').toInt() + (this.thumb_width + this.margin);
			if (move > 0) {
				move = 0;
			}
		} else if (side == 'right' && !this._thumbs_right.hasClass('inactive')) {
			var move = this._strip.getStyle('left').toInt() - (this.thumb_width + this.margin);
		}

		if (!this.move_strip) return;

		if (move || move == 0) {
			this.move_strip.start({
				'left': move
			}).chain(function () {
				this.thumbs_arrows_set_class();
			}.bind(this));
		}
	},

	move_thumbs_auto: function move_thumbs_auto(indx) {
		var half = Math.floor(this.options.width_by_thumbs / 2);
		var thumb_to_center;

		if (this.options.width_by_thumbs < this._thumbs.length) {
			if (indx <= half) {
				thumb_to_center = 0;
			} else if (indx >= this._thumbs.length - half - 1) {
				thumb_to_center = this.main_width - this.strip_width;
			} else {
				thumb_to_center = -(this._strip.getSize().x - (this._thumbs.length - indx + half) * (this.thumb_width + this.margin) + this.margin);
			}

			if (this._strip.getSize().x - this.thumb_width * indx < this._bottom.getSize().x) {
				thumb_to_center = -(this._strip.getSize().x - this._bottom.getSize().x);
			}

			if (!this.move_strip || this.strip_width <= this._bottom.getSize().x) {
				return;
			}

			this.move_strip.start({ 'left': thumb_to_center }).chain(function () {
				this.thumbs_arrows_set_class();
			}.bind(this));
		}
	},

	thumbs_arrows_set_class: function thumbs_arrows_set_class() {
		if (!this._strip) return;

		if (this._strip.getStyle('left').toInt() >= 0) {
			this._thumbs_left.addClass('inactive');
		} else {
			this._thumbs_left.removeClass('inactive');
		}

		if (this.strip_width <= this.main_width || this._bottom.getSize().x > this._strip.getSize().x + this._strip.getStyle('left').toInt()) {
			this._thumbs_right.addClass('inactive');
		} else {
			this._thumbs_right.removeClass('inactive');
		}
	},

	hide_controllers: function hide_controllers() {
		if (this.options.videos == true) {
			this.select_video_thumb(0);
		} else {
			this.select_thumb(0);
		}

		if (this._strip) {
			this._strip.getParent().hide();
			this._element.addClass('_no_thumbnails');
		}
	},

	update_caption: function update_caption(_th) {
		var _caption = this._element.getElement('.' + this.options.cls + '_caption span');

		if (!_caption) return;

		_caption.set('html', _th.getElement('img').get('title'));
	},

	move_caption: function move_caption() {
		var _caption = this._element.getElement('.' + this.options.cls + '_caption');

		if (!_caption) return;

		_caption.inject(this._element);
	},

	setImageCounter: function setImageCounter(indx) {
		if (this._image_counter) {
			this._image_counter.set('text', this.current_index + 1 + ' / ' + this._thumbs.length + (!!this.options.videos ? ' Videos' : ' Photos'));
		}
	},

	zoomin_floorplan: function zoomin_floorplan() {
		this._floorCurrentWidth += 200;
		if (this._floorCurrentWidth > this._floorMaxWidth) {
			this._floorCurrentWidth = this._floorMaxWidth;
		}
		this.zoomin_zoomout_floorplan_common();
		if (this._floorCurrentWidth > this._floorDefaultWidth) {
			this._main.setStyles({ 'overflow-x': 'scroll' });
		} else if (this._floorCurrentWidth <= this._floorDefaultWidth) {
			this._main.setStyles({ 'overflow-x': 'hidden' });
		}
	},

	zoomout_floorplan: function zoomout_floorplan() {
		this._floorCurrentWidth -= 200;
		if (this._floorCurrentWidth < this._floorMinWidth) {
			this._floorCurrentWidth = this._floorMinWidth;
		}
		this.zoomin_zoomout_floorplan_common();
		if (this._floorCurrentWidth > this._floorDefaultWidth) {
			this._main.setStyles({ 'overflow-x': 'scroll' });
		} else if (this._floorCurrentWidth <= this._floorDefaultWidth) {
			this._main.setStyles({ 'overflow-x': 'hidden' });
		}
	},

	zoomin_zoomout_floorplan_common: function zoomin_zoomout_floorplan_common() {
		if (this._floorCurrentWidth == this._floorDefaultWidth) {
			if (this._thumbs.length == 1 && !!this._current_full_img_cont) {
				var _img = this._current_full_img_cont.getElement('img');
				_img.setStyles({
					'width': 'auto'
				});
			} else {
				var self = this;
				this._thumbs.each(function (_el, _index) {
					_el._full_img.setStyles({
						'width': 'auto'
					});
					self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
				});
			}
		} else {
			if (this._thumbs.length == 1 && !!this._current_full_img_cont) {
				var _img2 = this._current_full_img_cont.getElement('img');
				_img2.setStyles({
					'width': this._floorCurrentWidth + 'px'
				});
			} else {
				var _self = this;
				this._thumbs.each(function (_el, _index) {
					_el._full_img.setStyles({
						'width': _self._floorCurrentWidth + 'px'
					});
					_self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? _self.verticalPadding : 0);
				});
			}
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Rater = new Class({
	Implements: [Events, Options],
	options: {
		max_size: 0, //height or width
		min_size: 0, //height or width === don't need to specify, if 'size' in this options is absolute
		max_data: 0, //max value through the elements === optional
		min_data: 0, //min value through the elements === optional
		property: 'data-height', //property of the elements where to take data
		animate: true,
		duration: 500,
		equal_speed: true, //if false, all animations will finish at the same time (duration),
		//if true, the speed for each animation is the same, so the smallest element will finish first
		transition: Fx.Transitions.linear,
		type: 'vertical', //vertical or horisontal
		size: 'absolute', //absolute or relative
		//IMPORTANT!: don't use 'relative' sizing if there is a possibility of negative values !!!!!!!!!!!!
		//if absolute, the size of each element counts from 0
		//i.e. - max_size is 100px,
		//and you have 5 elements with 'data-height's {20, 40, 60, 80, 100},
		//so, their sizes are going to be - {20, 40, 60, 80, 100}.
		//if relative, the size of each element counts from min_height
		//i.e. - max_size is 100px, min_size is 60px, and you have the same elements,
		//so, their sizes are going to be - {60, 70, 80, 90, 100}
		calculate_even_one_element: false //can be helpful when you use lazyLoader (in this case set to 'true')
	},

	initialize: function initialize(_elements, options) {
		this._elements = _elements;

		if (this._elements) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;

		if (this._elements.length == 0 || this._elements.length == 1 && !opts.calculate_even_one_element) return;

		this.max_data = opts.max_data;
		this.min_data = opts.min_data;
		this.has_negative = this.max_data < 0 || this.min_data < 0;

		if (opts.type == 'vertical') {
			this.max_size = opts.max_size == 0 ? this._elements[0].getSize().y : opts.max_size;
		} else {
			this.max_size = opts.max_size == 0 ? this._elements[0].getSize().x : opts.max_size;
		}

		if (this.max_size > 0) {
			opts.max_size = this.max_size;

			if (opts.animate == true) {
				if (opts.type == 'vertical') {
					this._elements.each(function (_el) {
						_el.setStyle('height', 0);
					});
				} else {
					this._elements.each(function (_el) {
						_el.setStyle('width', 0);
					});
				}
			}

			if (!this.max_data || this.max_data == 0) {
				this.get_values();
			}

			if (!(this.max_data == 0 && this.min_data == 0)) {
				this.calculate_size();
				this.set_size();
			}
		}
	},

	get_values: function get_values() {
		this._elements.each(function (_el) {
			var data = _el.getAttribute(this.options.property).toFloat() || 0;

			if (data > this.max_data) {
				this.max_data = data;
			}

			if (this.min_data > data || this.min_data == 0) {
				this.min_data = data;
			}

			if (data < 0) {
				this.has_negative = true;
			}
		}.bind(this));
	},

	calculate_size: function calculate_size() {
		var opts = this.options;

		if (this.options.size == 'relative') {
			var data_diff = this.max_data - this.min_data,
			    size_diff = opts.max_size.toInt() - opts.min_size.toInt();

			this._elements.each(function (_el) {
				var data = _el.getAttribute(opts.property).toFloat(),
				    this_size = opts.max_size;

				if (data_diff > 0) {
					this_size = opts.min_size + (data - this.min_data) * size_diff / data_diff;
				}

				_el.setAttribute('data-size', this_size);
			}.bind(this));

			if (this.min_data < 0) {
				console.warn("Don't use 'relative' sizing with negative values!");
			}
		} else {
			if (this.max_data > 0 && this.min_data >= 0) {
				this._elements.each(function (_el) {
					var data = _el.getAttribute(opts.property).toFloat();
					data = data > this.max_data ? this.max_data : data;

					var this_size = data * opts.max_size / this.max_data;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			} else if (this.max_data <= 0 && this.min_data < 0) {
				this._elements.each(function (_el) {
					var data = _el.getAttribute(opts.property).toFloat();
					data = data > this.max_data ? this.max_data : data;

					var this_size = data * opts.max_size / this.min_data * -1;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			} else if (this.max_data > 0 && this.min_data < 0) {
				var count_data = this.max_data + this.min_data * -1,
				    shift = this.min_data * opts.max_size / count_data * -1;

				if (opts.type == 'vertical') {
					this._elements.each(function (_el) {
						var _parent = _el.getParent();
						_parent.setStyle('height', _parent.getSize().y - shift);

						var data = _el.getAttribute(opts.property).toFloat();
						data = data > this.max_data ? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				} else {
					this._elements.each(function (_el) {
						var _parent = _el.getParent();

						_parent.setStyles({
							'margin-left': shift,
							'width': _parent.getSize().x - shift
						});

						var data = _el.getAttribute(opts.property).toFloat();
						data = data > this.max_data ? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				}
			}
		}
	},

	set_size: function set_size() {
		var _this = this;
		var opts = this.options;

		if (this.has_negative) {
			opts.animate = false;

			if (this.max_data <= 0) {
				this._elements.each(function (_el) {
					var _parent = _el.getParent();

					if (opts.type == 'vertical') {
						_parent.setStyle('height', 'auto');
					}
				}.bind(this));
			}
		}

		if (opts.animate == true) {
			this._elements.each(function (_el) {
				var size = _el.getAttribute('data-size').toFloat(),
				    this_time = opts.equal_speed == true ? size * opts.duration / opts.max_size : opts.duration,
				    animate = new Fx.Morph(_el, { duration: this_time, transition: opts.transition });

				if (opts.type == 'vertical') {
					animate.start({ 'height': [0, size] });
				} else {
					animate.start({ 'width': [0, size] });
				}

				(function () {
					animate = null;
				}).delay(this_time);
			});

			(function () {
				_this.fireEvent('animationDone');
			}).delay(opts.duration);
		} else {
			this._elements.each(function (_el) {
				var size = _el.getAttribute('data-size').toFloat(),
				    shift = 0;

				if (size < 0) {
					shift = size;
					size *= -1;
				}

				if (opts.type == 'vertical') {
					_el.setStyles({
						'height': size,
						'bottom': shift
					});
				} else {
					_el.setStyles({
						'width': size,
						'left': shift
					});
				}
			});
		}

		this.fireEvent('sizeSet');
	}
});
"use strict";

var SearchResultsMap = new Class({
	Implements: [Options, Events],

	options: {
		form: null,
		data_rpc: null,
		is_building: false,
		is_agents: false,
		label_on_marker: true,
		show_starting_price: false,
		search_type: null,
		counts_only: false, // show counts of the buildings per hood on firstload
		with_hover_icon: true,
		previous_state: null,
		page_context: null,
		icon_path: null,
		default_hood_id: null,
		is_click_style_hover: false,
		view: null,
		polygon: {
			idle: {
				strokeColor: "#bc3a5b",
				strokeWeight: 2,
				strokeOpacity: 0.4,
				fillColor: "#000000",
				fillOpacity: 0,
				clickable: true
			},
			hover: {
				fillColor: "#bc3a5b",
				fillOpacity: 0.35,
				clickable: true
			},
			active: {
				strokeColor: "#25B3E4",
				strokeWeight: 4,
				strokeOpacity: 0.8,
				fillColor: "#000000",
				fillOpacity: 0,
				clickable: false
			}
		},

		data: null
	},

	initialize: function initialize(map, options) {
		if (!map || !(map instanceof SimpleMap)) return;

		this.setOptions(options);

		this._form = this.options.form;
		this._button = this.options.button;

		this.map = map;

		this.page_id = $$('body')[0].get('id');

		this.state = new State();

		this.build();
	},

	build: function build() {
		var self = this;
		this.isFirstLoading = true;
		this.enabled = true;
		this.search_results_regions = [];
		this.rpc = this.options.data_rpc;

		if (!this.options.data) {
			self.get_data();
		} else {
			self.process_data();
		}
	},

	get_data: function get_data() {
		var self = this;
		var rpc = this.rpc;
		if (this.options.counts_only && this.options.is_building) {
			rpc += (rpc.indexOf('?') == -1 ? '?' : '&') + 'buildings=false';
		}

		if (this.options.filter_param) {
			rpc += (rpc.indexOf('?') == -1 ? '?' : '&') + this.options.filter_param;
		}

		new Remote({
			rpc: this._form != null ? this._form.getAttribute('data-rpc') + '?listings=1' : rpc,
			data: this._form != null ? '&' + this._form.toQueryString().trim() + '&ajax=1' : '',
			onSuccess: function onSuccess() {
				self.options.data = this.get_data();
				self.process_data();
			}
		});
	},

	refresh_data: function refresh_data(data, previous_region_id) {
		this.options.data = data;
		this.isFirstLoading = false;
		//don't show prev state after change criterias
		this.options.previous_state = null;
		if (this.map.current_marker) {
			this.has_opened_bubble = false;
			this.map.current_marker.marker.bubble.close();
		}
		this.process_data(previous_region_id);
	},

	process_data: function process_data(previous_region_id, changed_by_filter) {
		var self = this;
		var data = this.options.data;
		if (!data) return;

		this.map.clear_markers();
		this.fireEvent('dataLoad', data);

		this.icon_path = Res_i + '/w/simplemap/markers/';

		this.clear_regions();

		var region;
		var number_of_regions = this.number_of_regions = Object.getLength(data.listings || data.data);
		var previous_region;
		var avail_regions = [];
		var prev_state_region_id = this.options.previous_state ? this.options.previous_state.hood_id : null;
		var default_region;

		Object.each(data.listings || data.data, function (el, i) {

			var total = el.total || 0;
			var coords = el.coordinates || [];
			var has_marker;

			avail_regions.push(+i);
			//don't show marker for opened region or for restored region from previous state
			if (previous_region_id) {
				has_marker = i != previous_region_id;
			} else if (prev_state_region_id) {
				has_marker = i != prev_state_region_id;
			} else {
				has_marker = number_of_regions > 1;
			}

			region = this.set_nh(i, total, el.name, coords, has_marker);

			if (region) {
				region.url = el.url || '';
				region.name = el.name || 'Unknown';
				region.data = el.data;

				if (previous_region_id && changed_by_filter && region.region_id === previous_region_id && (data.listings || data.data)[region.region_id].data) {
					region.gross_data = (data.listings || data.data)[region.region_id].data;
				} else if (this.options.is_building && this.options.counts_only == false) {
					region.gross_data = data.data[region.region_id].data;
				} else if (!this.options.is_building && number_of_regions == 1 && data.listings[region.region_id].data) {
					region.gross_data = data.listings[region.region_id].data;
				}

				// if the region in the previous one
				if (region.region_id === prev_state_region_id || changed_by_filter && region.region_id === previous_region_id && region.gross_data) {
					previous_region = region;
				}

				if (parseInt(region.region_id, 10) === this.options.default_hood_id) {
					default_region = region;
				}
			}
		}.bind(this));

		//if thereis no data for opened region.
		if (this.current_region && avail_regions.indexOf(+this.current_region.region_id) == -1) {
			this.current_region = null;
		}

		if (number_of_regions == 1) {
			this.handle_region_click(region, this.options.previous_state);
		} else if (number_of_regions > 1) {
			if (this.isFirstLoading) {
				this.map.fit_markers();
			}
			// restore previous hood
			if (previous_region) {
				this.handle_region_click(previous_region, this.options.previous_state);
			} else if (default_region) {
				// select the default region
				this.handle_region_click(default_region);
			}
		}

		// process buildings
		if (data.buildings) {
			Object.each(data.buildings, function (el, i) {

				var building = el;
				var markerLabel = "\n\t\t\t\t\t<span class=\"arrow\"></span>\n\t\t\t\t\t<span class=\"tooltip\">\n\t\t\t\t\t\t<span class=\"tooltip-1\">" + Number(building.total).toLocaleString() + (Number(building.total) === 1 ? " Agent" : " Agents") + " in</span>\n\t\t\t\t\t\t<span class=\"tooltip-2\">" + building.name + "</span>\n\t\t\t\t\t</span>\n\t\t\t\t";
				var icon = this.icon_path + 'blg-1.png';
				var iconHover = this.icon_path + 'blg-hover-1.png';

				// var sm_marker = building.sm_marker = this.map.add_marker({
				var sm_marker = this.map.add_marker({
					lat: building.lat,
					lng: building.lng,
					icon: icon,
					// hover_icon: iconHover,
					base_point: 'center',
					// temporarily removed names from neighborhood markers
					label: {
						content: this.options.label_on_marker ? markerLabel : null,
						add_class: '_building'
					},
					scalable: true,
					callbacks: {
						onClick: function onClick() {
							self.handle_building_click(sm_marker, building);
						},

						onStopMouseover: function onStopMouseover() {
							self.handle_building_mouseover(sm_marker);
						},

						onMouseout: function onMouseout() {
							self.handle_building_mouseout(sm_marker);
						}

					}
				});

				var marker = sm_marker.marker;
			}.bind(this));
		}
	},
	clear_regions: function clear_regions() {
		if (this.search_results_regions) {
			this.search_results_regions.each(function (region) {
				region.setMap(null);
				if (region.sm_marker) {
					region.sm_marker.remove_from_map();
				}
			});
		}
		this.search_results_regions = [];
	},
	handle_region_click: function handle_region_click(region, previousState, changed_by_filter) {

		// if(!this.enabled || !region || region.is_active || !this.map.map.bubble_options.visible) return;
		if (!this.enabled || !region || !this.map.map.bubble_options.visible) return;

		var self = this;

		this.region_clicked = true;
		region.is_active = true;

		if (this.options.is_click_style_hover) {
			region.setOptions(this.options.polygon.hover);
		} else {
			region.setOptions(this.options.polygon.active);
		}

		this.fireEvent('request', region);

		if (!region.gross_data) {
			if (region.remote) {
				region.remote.cancel();
			}

			var rpc = this.rpc;
			rpc += rpc.indexOf('?') == -1 ? '?' : '&';

			if (self.options.counts_only && this.options.is_building) {
				rpc += 'hoodId=' + region.region_id;
			} else {
				rpc += 'hood=' + region.region_id;
			}

			if (this.options.filter_param) {
				rpc += '&' + this.options.filter_param;
			}

			region.remote = new Remote({
				rpc: self._form != null ? self._form.getAttribute('data-rpc') + '?listings=1&hoods[]=' + region.region_id : rpc,
				data: self._form != null ? '&' + self._form.toQueryString().trim() + '&ajax=1' : '',
				onSuccess: function onSuccess() {
					if ((this.get_data().listings || this.get_data().data)[region.region_id]) {
						region.gross_data = (this.get_data().listings || this.get_data().data)[region.region_id].data;

						// if filter has changed update the buildings of the current hood and the counts of the other hoods
						if (changed_by_filter) {
							self.options.data = this.get_data();
							self.process_data(region.region_id, changed_by_filter);
						} else {
							self.show_buildings(region, previousState);
						}
					} else if (changed_by_filter) {
						// if the current region doesnt have data pass, we still need to update the count of the other hoods
						self.options.data = this.get_data();
						self.process_data();
					}

					self.fireEvent('dataLoad', region);
				}
			});
		} else {
			this.show_buildings(region, previousState);
			this.fireEvent('dataLoad', region);
		}

		if (this.current_region && this.current_region.region_id !== region.region_id) {
			this.deactive_current_region();
		}

		if (this.current_building) {
			this.deactive_current_building();
			this.current_building = null;
		}

		if (this.current_big_bubble) {
			this.current_big_bubble.close();
		}

		if (this.isFirstLoading) {
			this.fit_region(region);
		}

		if (this.options.is_click_style_hover) {
			region.setOptions(this.options.polygon.hover);
		} else {
			region.setOptions(this.options.polygon.active);
		}

		this.current_region = region;

		_gaq.push(['_trackEvent', 'map', 'loaded', 'view_region']);
	},

	deactive_current_region: function deactive_current_region() {
		this.current_region.in_region = false;
		this.current_region.is_active = false;

		if (this.current_region.building_markers) {
			this.current_region.building_markers.each(function (el) {
				el.remove_from_map();
			});
		}
		if (this.current_region.marker) {
			this.current_region.marker.setMap(this.map.map);

			if (this.current_region.marker.label) {
				this.current_region.marker.label.open();
			}
		} else {
			this.set_marker(this.current_region);
		}
		this.handle_region_mouseout(this.current_region);
	},

	deactive_current_building: function deactive_current_building() {
		if (this.current_building) {
			this.current_building.marker.icon.url = this.icon_path + 'blg-1.png';
			this.current_building.change_icon_image(this.icon_path + 'blg-1.png');
			$(this.current_building.marker.label._bubble_content).removeClass('hover');
		}
	},

	set_marker: function set_marker(region) {
		var self = this;
		var markerLabel;
		var icon;

		// marker special for agents map
		if (this.options.is_agents) {
			markerLabel = "\n\t\t\t\t<span class=\"number\">" + Number(region.total).toLocaleString() + "</span>\n\t\t\t\t<span class=\"text\">" + (Number(region.total) === 1 ? "Agent" : "Agents") + "</span>\n\t\t\t";
			// icon =  this.icon_path + 'blg-1.png';
			icon = self.icon_path + 'region-marker.png';
		} else {
			// default markers
			markerLabel = '<span class="number">' + Number(region.total).toLocaleString() + '</span>';
			icon = self.icon_path + 'region-marker.png';
		}

		var sm_marker = region.sm_marker = this.map.add_marker({
			lat: region.center_lat,
			lng: region.center_lng,
			icon: icon,
			base_point: 'center',
			// temporarily removed names from neighborhood markers
			label: {
				content: self.options.label_on_marker ? markerLabel : null,
				add_class: '_hood'
			},
			scalable: true
		});

		var marker = region.marker = sm_marker.marker;

		this.add_events(marker, region);
	},

	set_nh: function set_nh(id, total, name, coordinates, has_marker) {
		if (!coordinates || typeOf(coordinates) != 'array' || coordinates.length < 3) return null;

		var coords = [],
		    most_top_lat,
		    most_bottom_lat,
		    most_left_lng,
		    most_right_lng,
		    center_lat,
		    center_lng,
		    center_latlng;

		var opts = this.options.polygon;

		coordinates.each(function (el) {
			if (el[0] && el[1]) {
				var latlng = new google.maps.LatLng(el[1], el[0]);
				coords.push(latlng);

				if (!most_top_lat || el[1] > most_top_lat) {
					most_top_lat = el[1];
				}

				if (!most_bottom_lat || el[1] < most_bottom_lat) {
					most_bottom_lat = el[1];
				}

				if (!most_left_lng || el[0] < most_left_lng) {
					most_left_lng = el[0];
				}

				if (!most_right_lng || el[0] > most_right_lng) {
					most_right_lng = el[0];
				}
			}
		});

		center_lat = (most_top_lat + most_bottom_lat) / 2;
		center_lng = (most_left_lng + most_right_lng) / 2;

		if (coords.length < 3) return null;

		var map = this.map.map;

		var region = new google.maps.Polygon({
			paths: coords
		});
		//keep coords to create marker later
		region.center_lat = center_lat;
		region.center_lng = center_lng;
		region.total = total;

		region.region_id = id;

		region.setOptions(opts.idle);

		this.search_results_regions.push(region);

		region.setMap(map);

		region.coordinates = coordinates;

		name = name.replace('/ ', '/');
		name = name.replace(' /', '/');
		name = name.replace(' / ', '/');
		name = name.replace('/', ' /<br/>');

		this.add_events(region, region);

		if (has_marker) {
			this.set_marker(region);
		}

		return region;
	},

	add_events: function add_events(marker, region) {
		var self = this;
		google.maps.event.addListener(marker, 'click', function () {
			self.handle_region_click(region);
		});

		google.maps.event.addListener(marker, 'mouseover', function () {
			self.handle_region_mouseover(region);
		});

		google.maps.event.addListener(marker, 'mousemove', function () {
			self.handle_region_mousemove(region);
		});

		google.maps.event.addListener(marker, 'mouseout', function () {
			self.handle_region_mouseout(region);
		});
	},

	handle_region_mouseover: function handle_region_mouseover(region) {
		if (!this.enabled || !region) return;

		if (region.is_active || region.in_region) return;

		//(function(){
		region.setOptions(this.options.polygon.hover);
		//}.bind(this)).delay(20);

		region.in_region = true;
	},

	handle_region_mousemove: function handle_region_mousemove(region) {
		if (!this.enabled || !region) return;

		if (this.map.map.bubble_options.visible) {
			this.handle_region_mouseover(region);
		} else {
			this.handle_region_mouseout(region);
		}
	},

	handle_region_mouseout: function handle_region_mouseout(region) {
		if (!this.enabled || !region || region.is_active) return;

		(function () {
			if (!region.in_region) {
				region.setOptions(this.options.polygon.idle);
			}
		}).bind(this).delay(20);

		region.in_region = false;
	},

	handle_building_click: function handle_building_click(smmarker, building) {

		this.deactive_current_region();

		this.deactive_current_building();

		this.current_building = smmarker;

		smmarker.change_icon_image(this.icon_path + 'blg-hover-1.png');
		$(smmarker.marker.label._bubble_content).addClass('hover');

		this.fireEvent('request', building);
	},

	handle_building_mouseover: function handle_building_mouseover(smmarker) {
		smmarker.change_icon_image(this.icon_path + 'blg-hover-1.png');
		$(smmarker.marker.label._bubble_content).addClass('hover');
	},

	handle_building_mouseout: function handle_building_mouseout(smmarker) {
		if (this.current_building === smmarker) return;

		smmarker.change_icon_image(this.icon_path + 'blg-1.png');
		$(smmarker.marker.label._bubble_content).removeClass('hover');
	},

	fit_region: function fit_region(region) {
		if (!region) return;
		var bounds = new google.maps.LatLngBounds();
		var points = [];

		region.coordinates.each(function (el) {
			var point = new google.maps.LatLng(el[1], el[0]);
			bounds.extend(point);
			points.push(point);
		});

		this.map.map.fitBounds(bounds);
	},

	show_buildings: function show_buildings(region, previousState) {

		var data = region.gross_data;

		if (!data || data.length == 0) return;

		var self = this;

		if (region.sm_marker) {
			region.sm_marker.remove_from_map();
		}

		if (region.building_markers) {
			region.building_markers.each(function (el) {
				el.marker.setMap(self.map.map);
				if (el.marker.label) {
					el.marker.label.open();
				}
			});

			return;
		}

		region.building_markers = [];

		Object.each(data, function (el, i) {
			if (!self.in_new_york(el.lat, el.lng)) return;

			var total = (el.total && el.total > 1 ? el.total : '') + '';

			var marker;
			var currentBuildingId = 'building-' + i;

			// set if you want to open the tooltip for this marker
			var initOpen = previousState && previousState.building_id === currentBuildingId ? true : false;

			var sm_marker = self.map.add_marker({
				id: currentBuildingId,
				init_open: initOpen,
				lat: el.lat,
				lng: el.lng,
				label: {
					content: self.options.label_on_marker ? '<span class="">' + total + '</span>' : '<span class="">' + total + '</span>', //
					add_class: '_building _' + i + (total.length > 0 ? ' _with_count _size_' + (total.length > 4 ? 4 : total.length) : '') + (el.offer_tag_id ? ' _offer_' + el.offer_tag_id : '')
				},
				icon: (self.options.icon_path || self.icon_path) + (total.length > 4 ? 4 : total.length) + '.png',
				hover_icon: self.options.with_hover_icon ? self.icon_path + (total.length > 4 ? 4 : total.length) + '-hover-red.png' : null,
				bubble: {
					content: self.get_bubble_content(el),
					add_class: self.options.is_building ? '_building' : '_big',
					offset: {
						x: 16,
						y: -45
					},
					side: 'right'
				},
				base_point: 'center',
				center_on_click: self.options.is_building ? true : false,
				current_bubble_open_on_mouseover: self.options.is_building ? true : false,
				onBubbleReady: function onBubbleReady(_el) {
					if (el.bubble_is_ready) return;

					var _ul = _el.getElement('ul');

					_el.addEvents({
						'mouseenter': function mouseenter() {
							self.in_bubble = true;
						},

						'mouseleave': function mouseleave() {
							self.in_bubble = false;

							// if(self.options.is_building){
							//	 _el.getElement('.w_googlemaps_infobox_content').set('html', self._prev_content);
							// }
						}
					});

					if (_ul && _ul.getSize().y > _el.getSize().y) {
						_ul.setStyles({
							'overflow-y': 'scroll',
							'max-height': 210
						});
					}

					var _lis = _el.getElements('li');

					_lis.each(function (_e) {
						if (_e.getAttribute('data-rpc')) {
							var tmpRpc = _e.getAttribute('data-rpc');
							if (tmpRpc.indexOf('/rpc/listing-popup') != -1) {
								_e.setAttribute('data-rpc', tmpRpc.replace('/rpc/listing-popup', '/rpc/listing-popup-v2'));
							}
							var display = 'map';
							if (_e.getAttribute('data-images-cnt') && parseInt(_e.getAttribute('data-images-cnt'), 10) > 0) {
								display = 'gallery';
							}
							_e.blimp = new BlimpExtV2(_e, {
								cache: true,
								draggable: true,
								show_veil: true,
								display: display,
								withThumbnails: true,
								fullscreen: true,

								onFetch: function onFetch() {
									// Save state : send event to mapmultipleview, because we need the criteria etc
									self.fireEvent('saveState', { building_id: currentBuildingId });

									sm_marker.marker.clicked = true;
									self.region_clicked = false;
									self.fireEvent('request');

									_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
								},

								onPostRpc: function onPostRpc() {
									this.add_extra(true);

									self.fireEvent('dataLoad');

									Core.compile_html(this._element);
								},

								onHide: function onHide() {
									// delete state
									self.state.remove(self.page_id);

									if (this.email_blimp) {
										this.email_blimp.hide();
									}

									if (this.save_blimp) {
										this.save_blimp.hide();
									}
								}
							});
						} else if (_e.getAttribute('data-url')) {
							_e.addEvent('click', function () {
								window.location = _e.getAttribute('data-url');
							});
						}
					});

					if (_ul) {
						_ul.addEvent('click:relay("li a")', function (e, i) {
							if (e && e.stop) e.stop();

							self.fireEvent('request', [e, i]);
						});
					}

					el.bubble_is_ready = true;
				},

				callbacks: {
					onClick: function onClick() {
						// open the buble when the user click the other marker and close the current open bubble.
						if (self.map.current_marker && self.map.current_marker != sm_marker) {
							self.has_opened_bubble = false;

							if (self.options.is_building) {
								if (self.map.current_marker) {
									self.map.current_marker.marker.bubble.close();
								}
							}

							if (self.map.current_marker.marker.label && self.map.current_marker.marker.label._bubble_content) {
								self.map.current_marker.marker.label._bubble_content.removeClass('_active');
							}

							google.maps.event.trigger(sm_marker.marker, "mouseover");
						}

						self.has_opened_bubble = true;

						self.map.current_marker = sm_marker;

						self.current_big_bubble = sm_marker.marker.bubble;

						// add active class to the label of the current marker
						if (self.map.current_marker.marker.label && self.map.current_marker.marker.label._bubble_content) {
							self.map.current_marker.marker.label._bubble_content.addClass('_active');
						}

						if (!self.options.is_building) return;

						(function () {
							var _bubble = sm_marker.marker.bubble.infobox._div;

							if (!_bubble) return;

							_bubble.addClass('_big');

							sm_marker.marker.bubble.open();

							if (_bubble.rater) return;

							var _inds = _bubble.getElements('.indicator');

							_bubble.rater = new Rater(_inds, {
								'property': 'data-value',
								'size': 'absolute',
								'animate': false,
								'type': 'horisontal',
								'max_size': 284
							});
						}).delay(10);
					},

					onMouseout: function onMouseout() {
						if (self.options.is_building && !sm_marker.marker.clicked) {
							if (sm_marker.marker.bubble && sm_marker.marker.bubble.infobox) {
								var _bubble = sm_marker.marker.bubble.infobox._div;

								if (!_bubble) return;

								sm_marker.marker.bubble.infobox._div.removeClass('_big');
							}
						}
					},

					onStopMouseover: function onStopMouseover() {
						if (!self.options.is_building && self.has_opened_bubble) {
							return true;
						}

						return false;
					},

					onBubbleClose: function onBubbleClose() {
						self.has_opened_bubble = false;

						// remove the active class to the label of the current marker when the bubble is closed.
						if (self.map.current_marker && sm_marker === self.map.current_marker && self.map.current_marker.marker.label && self.map.current_marker.marker.label._bubble_content) {
							self.map.current_marker.marker.label._bubble_content.removeClass('_active');
						}
					}
				}
			});

			region.building_markers.push(sm_marker);
		});
	},

	get_bubble_content: function get_bubble_content(data) {
		var header = '';

		if (data.name && data.name != '') {
			header += '<span>' + data.name + '</span>' + data.address + (data.type && data.type != '' ? '<br/>' : '') + '<span class="type' + (data.type.toLowerCase() == 'rental' ? ' _dark' : '') + '">' + data.type + '</span>';
		} else {
			header += '<span>' + data.address + '</span>';
		}

		var content;

		if (this.options.is_building) {
			content = this.get_building_map_bubble_content(data);
		} else {
			var self = this;
			var listings_amount = 0;
			var lis = '';

			this.bubble_images = [];

			Object.each(data.data, function (el) {
				var add_class = el.mask_id ? ' _' + el.mask_id : '';
				var url = self.options.page_context ? el.url + '&pageContext=' + self.options.page_context : el.url;
				if (typeof self.options.view != "undefined" && self.options.view) {
					url += "&view=" + self.options.view;
				}

				var image = window.Missing_img_horisontal;
				var imagesCnt = 0;
				if (el.thumbor_images && el.thumbor_images.length > 0) {
					image = Core.get_smart_image(120, 78, el.thumbor_images[0]);
					imagesCnt = el.thumbor_images.length;
				} else {
					image = el.image;
				}
				lis += '<li data-class="w_blimp_listing" class="clearfix ' + add_class + '" data-' + (el.sold ? 'url' : 'rpc') + '="' + url + '" data-images-cnt="' + imagesCnt + '">' + '<span class="image left">' + '<img src="' + image + '" onerror="this.src=\'' + Missing_img_horisontal + '\';"/>' + '</span>' + '<span class="description">' + (el.unit && el.unit != '' ? '<span class="name ' + (el.in_contract ? '' : 'mt_10') + '">Apt. ' + el.unit + '</span>' : '') + (el.display_bedrooms ? el.display_bedrooms : '') + (el.display_bathrooms ? ', ' + el.display_bathrooms : '') + (el.price ? '<span class="price">' + el.price + '</span>' : '') + (self.options.search_type == 'transactions' && el.sale_date ? '<span class="sold_date"> Sold ' + el.sale_date + '</span>' : '') + (el.in_contract ? '<span class="flag_incontract">In contract</span>' : '') + '</span>' + '</li>';

				listings_amount++;

				self.bubble_images.push(el.image);
			});

			content = '<h3>' + header + '</h3>' + '<ul>' + lis + '</ul>';
		}

		return content;
	},

	get_building_map_bubble_content: function get_building_map_bubble_content(data) {
		var bubble = '' + '<div class="clearfix">' + '<div class="photo_container">' + '<a href="' + data.url + '"><img src="' + (data.photo ? data.photo : Missing_img) + '" onerror="this.src=\'' + Missing_img + '\';"/></a>' + '</div>' + '<div class="info_container clearfix">' + '<div class="name">' + '<a href="' + data.url + '">' + (data.name ? data.name : data.address) + '</a>' + '</div>' + (data.name && data.address ? '<div class="address"><a href="' + data.url + '">' + data.address + '</a></div>' : '') + (data.type ? '<div class="type">' + data.type + '</div>' : '');

		if (this.options.show_starting_price) {
			if (data.avg_price && data.avg_price != '' || data.total && data.total != '') {
				if (data.avg_price && data.avg_price != '') {
					bubble += '<div class="starting_price">' + 'Starting from $<strong>' + Core.add_commas(data.avg_price.toFixed()) + '</strong>' + '</div>';
				}

				if (data.total && data.total != '') {
					bubble += '<div class="available_apts">' + 'Apt' + (data.total > 0 ? 's' : '') + ' Available for ' + (data.type.capitalize() != 'Rental' ? 'sale' : 'rent') + ': <strong>' + data.total + '</strong>' + '</div>';
				}
			} else {
				bubble += '<div class="no_price">No price information available</div>';
			}
		} else {
			if (data.avg_ppsqft && data.avg_ppsqft != '' && data.listings_avg_ppsqft && data.listings_avg_ppsqft != '') {
				bubble += '<div class="avg_price">' + '<div class="price">$' + Core.add_commas(data.avg_ppsqft.toFixed()) + '</div>' + 'Avg. Price / Ft<sup>2</sup> (Recent Closings)' + '<div class="indicator building" data-value="' + data.avg_ppsqft + '">&nbsp;</div>' + '<strong>$' + Core.add_commas(data.listings_avg_ppsqft.toFixed()) + '</strong>' + 'Avg. Price / Ft<sup>2</sup> (Currently Available)' + '<div class="indicator listing" data-value="' + data.listings_avg_ppsqft + '">&nbsp;</div>' + '</div>';
			} else if (data.avg_ppsqft && data.avg_ppsqft != '' || data.listings_avg_ppsqft && data.listings_avg_ppsqft != '') {
				var price = data.avg_ppsqft && data.avg_ppsqft != '' ? data.avg_ppsqft : data.listings_avg_ppsqft;
				var spec = data.avg_ppsqft && data.avg_ppsqft != '' ? 'Recent Closings' : 'Currently Available';

				price = Core.add_commas(price.toFixed());

				bubble += '<div class="avg_price no_indicator building">' + '<div class="price">$' + price + '</div>' + 'Avg. Price / Ft<sup>2</sup> (' + spec + ')' + '</div>';
			} else if (data.providers && data.url.contains('furnished')) {
				bubble += '<div class="providers"><strong>' + data.providers + (data.providers > 1 ? ' companies' : ' company') + '</strong> w/ Furnished Apartments</div>';
			} else {
				bubble += '<div class="no_price">No price information available</div>';
			}
		}

		bubble += (data.url ? '<a class="button" href="' + data.url + '">View Complete Building Info</a>' : '') + '</div>' + '</div>' + '<span class="legend">Click on marker for more info</span>';

		return bubble;
	},

	in_new_york: function in_new_york(lat, lng) {
		//some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if (!lat || !lng) return false;

		return lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4;
	},

	enable: function enable() {
		this.enabled = true;
	},

	disable: function disable() {
		this.enabled = false;
	}
});
'use strict';

var Streetview = new Class({
	Implements: [Options, Events],

	options: {
		cls: "w_streetview",
		container: null,
		zoomControl: true
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			Core.load_google_api(this.build.bind(this));
		}
	},

	build: function build() {
		var _self = this._element,
		    opts = this.options,
		    cls = opts.cls;

		this.mode = 'webgl';
		this.check_webgl();

		var _config = _self.getElement('.' + cls + '_config');
		var _pano = this._pano = _self.getElement('.' + cls + '_pano');

		if (_pano && _config) {
			var config = this.config = JSONMOO.decode(_config.get('text').toString().trim(), false);
			config.mode = this.mode;

			if (!config.position && config.lat && config.lng) {
				config.position = new google.maps.LatLng(config.lat, config.lng);
			}

			var default_config = {
				position: new google.maps.LatLng(40.7642676, -73.9741554),
				addressControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				zoomControl: opts.zoomControl
			};

			var final_config = Object.merge(default_config, config);
			var service = this.service = new google.maps.StreetViewService();

			if (final_config.pov && Object.keys(final_config.pov).length) {
				this.init_pano(final_config);
			} else {
				var panoRequest = {
					location: final_config.position,
					preference: google.maps.StreetViewPreference.NEAREST,
					radius: final_config.radius || 50,
					source: google.maps.StreetViewSource.OUTDOOR
				};
				service.getPanorama(panoRequest, function (pano_data, status) {
					if (status == google.maps.StreetViewStatus.OK) {
						var angle = this.compute_angle(final_config.position, pano_data.location.latLng);

						final_config.pov = {
							'heading': angle,
							'pitch': 0,
							'zoom': 1,
							'pano_data': pano_data
						};
					} else {
						final_config.pov = null;
					}
					this.init_pano(final_config);
				}.bind(this));
			}
		}
	},

	check_webgl: function check_webgl() {
		var canvas = new Element('canvas'),
		    contextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
		    gl = null;

		contextNames.each(function (e, i) {
			if (!gl) {
				try {
					gl = canvas.getContext(contextNames[i]);
				} catch (e) {}
			}
		});

		canvas = null;

		if (gl === null) this.mode = 'html4';
	},

	init_pano: function init_pano(config) {
		if (config.pov.pano_data.location.pano) {
			config.pano = config.pov.pano_data.location.pano;
		}
		var pano = this.pano = new google.maps.StreetViewPanorama(this._pano, Object.merge(config, { visible: true }));

		var marker_config = {
			'position': config.position,
			'clickable': false,
			'map': pano
		};

		if (config.marker) {
			marker_config = Object.merge(marker_config, config.marker);
		}

		this.base_marker = new google.maps.Marker(marker_config);
	},

	compute_angle: function compute_angle(end, start) {
		var DEGREE_PER_RADIAN = 57.2957795;
		var RADIAN_PER_DEGREE = 0.017453;
		var dlat = end.lat() - start.lat();
		var dlng = end.lng() - start.lng();
		var angle = Math.atan2(dlng * Math.cos(end.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN;

		if (angle >= 360) {
			angle -= 360;
		} else if (angle < 0) {
			angle += 360;
		}
		return angle;
	}
});
'use strict';

var BlimpExtPricehistory = new Class({
	Extends: BlimpExt,

	post_process_build: function post_process_build() {
		var _table = this._element.getElement('.w_pricehistory_table') || this._element.getElement('.w_pricehistory_fullscreen_table');;
		var tbody = _table.getElement('.tbody');

		if (this.is_initialized) {
			return;
		}

		if (this.options.page === 'lst' || this.options.vscroll) {
			new StyledScroll(tbody, {
				type: 'v',
				max_height: 300
			});
		}

		var _diagram = this._element.getElement('.diagram');

		if (_diagram) {
			_diagram.setStyle('height', _table.getSize().y);

			var data = JSONMOO.decode(_diagram.get('html'), false);

			_diagram.set('html', '');

			new Phgraph(_diagram, {
				'size': 'small',
				'data': data.reverse() // need to reverse the order so it will be display properly in the chart
			});
		}

		this.parent();
		this.is_initialized = true;
	}

});
'use strict';

Page.Lco = new Class({
	Extends: Page,
	build: function build() {
		document.getElements('.w_photogalleryv2').each(function (_el) {
			new PhotogalleryV2(_el, {
				width_by_thumbs: 7
			});
		});

		document.getElements('.td.description').each(function (_el) {
			new Shrinker(_el, {
				min_height: 315,
				toggler: _el.getNext('.w_shrinker_head'),
				single_opened: false,
				onShrink: function onShrink() {
					this._toggler.removeClass('_opened');
					this._toggler.set('html', 'Show More<span>&nbsp;</span>');
				},

				onUnshrink: function onUnshrink() {
					this._toggler.addClass('_opened');
					this._toggler.set('html', 'Show Less<span>&nbsp;</span>');
				}
			});
		});

		var max_ava = document.getElement('.tbody').getAttribute('data-max-available-apts');

		new Rater(document.getElements('.td.ava .indicator'), {
			'property': 'data-value',
			'size': 'absolute',
			'animate': true,
			'type': 'horisontal',
			'duration': 1500,
			'equal_speed': true,
			'max_data': max_ava,
			'calculate_even_one_element': true
		});

		this.parent();

		// document.getElements('#display_region, #listings_order').each(function(_el){
		// 	_el.addEvent('change', function(){
		// 		var _option = _el.getElement(':selected'),
		// 				url = _option.getProperty('data-href');
		//
		// 		window.location = url;
		// 	});
		// });
		//
		// document.getElements('.view_on_map').each(function(_el){
		// 	new BlimpExtMap(_el, {
		// 		draggable: true
		// 	});
		// });
		//
		// new MapView();
		//
		// var region_multiselect = new Multiselect(document.getElement('.w_multiselect'), {
		// 	text_input: false,
		// 	close_button: false,
		// 	suspension_points: true,
		// 	equality: false,
		// 	add_tiles: false,
		// 	onClick: function(e){
		// 		if(e) e.preventDefault();
		//
		// 		var count = 0;
		// 		var regions = '?regions[]=';
		//
		// 		this._children.each(function(_el){
		// 			if(_el.hasClass('_selected')){
		// 				if(count >= 1){
		// 					regions += '&regions[]=';
		// 				}
		//
		// 				regions += _el.get('data-region-id');
		// 				count++;
		// 			}
		// 		});
		//
		// 		location.href = this._element.get('data-url') + regions;
		// 	}
		// });
		//
		// region_multiselect.update_monitor();
	}
});
//# sourceMappingURL=lco.js.map
